import { withStylePrefix } from '../common/withStylePrefix';
import { CodeSnippetComponent, codeSnippetTemplate } from './CodeSnippet';
import styles from './CodeSnippet.styles.scss';
export const codeSnippetDefinition = {
    baseName: 'code-snippet',
    template: codeSnippetTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonCodeSnippet = CodeSnippetComponent.compose(codeSnippetDefinition);
